module.exports = __webpack_public_path__ + "static/media/ProximaNova-Black.3880e2f4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova/ProximaNova-Black.ttf
// module id = 221
// module chunks = 0